export const getOfertas = () => {
  return `query {
    ofertas {
        descripcion
        imagen {
            url
        }
        categoria {
            nombre
        }
    }
    }`;
}
